<div class="multiadd">

  <div class="multiadd-grid p-b-10">

    <nz-select nzShowSearch  [ngModel]="'Business'">
      <nz-option [nzLabel]="'Personal'" [nzValue]="'Personal'"></nz-option>
      <nz-option [nzLabel]="'Business'" [nzValue]="'Business'"></nz-option>
    </nz-select>

    <input type="text" nz-input placeholder="{{placeholderVal}}"/>

    <!-- Button to ADD ROW (`FIRST ROW` WILL HAVE THIS) -->
    <button nz-button nzType="dashed" (click)="addRow()">
      <i nz-icon nzType="plus"  nzTheme="outline"></i>
    </button>

  </div>

  <!-- REPEAT ROWS -->
  <!-- Heading -->
  <div class="multiadd-grid multiadd-grid-4" *ngIf="rows.length">
    <small class="f-s-tiny">Preferred</small>
  </div>
  <!-- Rows -->
  <div class="multiadd-grid multiadd-grid-4" *ngFor="let row of rows; let i = index;">

    <div class="flex flex-both-center">
      <div>
        <nz-radio-group [(ngModel)]="preferred">
          <label nz-radio [nzValue]="i" class="m-r-0"></label>
        </nz-radio-group>
      </div>
    </div>

    <nz-select nzShowSearch  [ngModel]="'Business'">
      <nz-option [nzLabel]="'Personal'" [nzValue]="'Personal'"></nz-option>
      <nz-option [nzLabel]="'Business'" [nzValue]="'Business'"></nz-option>
    </nz-select>
    <!-- Input -->
    <input type="text" nz-input placeholder="{{placeholderVal}}"/>

    <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this row?" nzOkText="Remove" nzCancelText="Cancel"
            (nzOnConfirm)="removeRow()">
      <i nz-icon nzType="delete" nzTheme="outline"></i>
    </button>
  </div>

</div>
